import type { FC, ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

type CardProps = {
  children: ReactNode
  title?: string
  className?: string
  type?: 'default' | 'primary' | 'secondary'
}

export const Card: FC<CardProps> = (props) => {
  const { children, title, className = '', type = 'default' } = props

  return (
    <div className={twMerge('card', `card--${type}`, className)}>
      {title && (
        <>
          <div className={`card__title card__title--${type}`}>{title}</div>
          {type === 'default' && <hr className="card__divider" />}
        </>
      )}
      {children}
    </div>
  )
}
